import { environment } from '@env/environment';

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ModalAlertService } from '@app/shared/services/modal-alert.service';
import { Messages } from '@app/shared/enums/messages.enums';


@Injectable()

export class HttpService {
  private API = '';
  private handleError: boolean;

  constructor(private http: HttpClient, private modal: ModalAlertService) {
    this.API = environment.api;
  }

  PutRequest = <TResult, TSource>(request: string, body: TSource, handleError: boolean = true): Observable<TResult> => {
    this.handleError = handleError;
    return this.filterRequest(this.http.put(`${this.API}${request}`, body));
  }
  PatchRequest = <TResult, TSource>(request: string, body: TSource, handleError: boolean = true): Observable<TResult> => {
    this.handleError = handleError;
    return this.filterRequest(this.http.patch(`${this.API}${request}`, body));
  }
  UpdateRequest = <TResult, TSource>(request: string, body: TSource, handleError: boolean = true): Observable<TResult> => {
    this.handleError = handleError;
    return this.filterRequest(this.http.put(`${this.API}${request}`, body));
  }
  DeleteRequest = <TResult, TSource>(request: string, body: TSource, handleError: boolean = true): Observable<TResult> => {
    this.handleError = handleError;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: body
    };
    return this.filterRequest(this.http.delete(`${this.API}${request}`, options));
  }
  GetRequest = <TResult>(request: string, handleError: boolean = true): Observable<TResult> => {
    this.handleError = handleError;
    return this.filterRequest(this.http.get<TResult>(`${this.API}${request}`));
  }
  PostRequest = <TResult, TSource>(request: string, body: TSource, handleError: boolean = true): Observable<TResult> => {
    this.handleError = handleError;
    const _headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.filterRequest(this.http.post(`${this.API}${request}`, body, { headers: _headers }));
  }
  PostRequestFormData = <TResult, TSource>(request: string, body: TSource, handleError: boolean = true): Observable<TResult> => {
    this.handleError = handleError;
    return this.filterRequest(this.http.post(`${this.API}${request}`, body));
  }

  private filterRequest = <TResult>(obs: Observable<Object>): Observable<TResult> => {
    return obs.pipe(catchError((errorResponse: HttpErrorResponse): Promise<any> => {
      if (errorResponse.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', errorResponse.error.message);
      } else {
        switch (errorResponse.status) {
          case 0:
            this.modal.showAlert({ data: { error: Messages.mustCheckConnection } });
            break;
          case 401:
            console.log('The user is not authenticated, httpinterceptor must handle this');
            break;
          case 403:
            this.handleError && this.modal.showAlert({ data: { error: errorResponse.error } });
            break;
          case 404:
            this.handleError && this.modal.showAlert({ data: { error: errorResponse.error } });
            break;
          default:
            console.log(
              `Backend returned code ${errorResponse.status}, ` +
              `body was: ${errorResponse.error}`);
            this.modal.showAlert({ data: { error: 'Ups, algo ha salido mal :(' } });
            break;
        }
      }
      return Promise.reject(errorResponse);
    }));
  }
}
